import React, { useState, useEffect } from "react";
import { Redirect, Route, Link } from "react-router-dom";
import api from "services/api";
import DOMPurify from "dompurify";
import Banner from "elements/Banner";
import CustomerReviews from "elements/CustomerReviews";
import { Helmet } from "react-helmet";
import { __ } from "services/Translator";

export default function VipCard(props) {
  const isAuthenticated = props.isAuthenticated;
  const [pageContent, setPageContent] = useState({});
  const getResults = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "vip",
    });
    if (response.status === 200) {
      setPageContent(response.data.content_data);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  useEffect(() => {
    // getResults();
  }, []);
  return (
    <>
      <Helmet>
        <title>{__("Blizz Casino | Become a VIP and get all the Rewards that go with it!")}</title>
        <meta
          name="description"
          content={__(
            "Blizz Casino! We value all our players of course, become a ViP though and get extra rewards, bonuses and more!"
          )}
        />
      </Helmet>

      <div className="vip_card">
        <section className="banner_vip_card">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-5">
                <div className="banner_heading">{__("Blizz Loyalty Program!")}</div>
                <div className="banner_paragraph">
                  {__(
                    "We love loyalty and will reward it in the best way possible – more promotions, more cashback, more surprises, more everything! The more you play, the more you will get back – that's a promise!"
                  )}
                </div>
                <div className="banner_button">
                  {props.isAuthenticated ? (
                    <Link to="/games/live-casino" className="common_btn_v1 width_100">
                      {__("START NOW!")}
                    </Link>
                  ) : (
                    <>
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          setTimeout(function () {
                            props.setModalSignUpPropsData(false);
                          }, 500);
                        }}
                        className="common_btn_v1 width_100"
                      >
                        {__("START NOW!")}
                      </Link>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-7">
                <div className="card_banner_img">
                  <img alt="" src={require("assets/images/v1/vip/vip-card-banner.svg").default} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="rewards padding_top_30">
          <div className="container">
            <div className="heading"> {__("Level up your Rewards!")}</div>
            <div className="paragraph">
              {__(
                "The more you play, the higher your level will become. Get all the way to Diamond VIP and get a service like no other Crypto Casino site offers you!"
              )}
            </div>
            <div className="table_area">
              <div className="rewards_table">
                <div className="data_heading">
                  <div className="item"></div>
                  <div className="item">
                    <img alt="" src={require("assets/images/v1/vip/bronze-card.svg").default} />
                  </div>
                  <div className="item">
                    <img alt="" src={require("assets/images/v1/vip/silver-card.svg").default} />
                  </div>
                  <div className="item">
                    <img alt="" src={require("assets/images/v1/vip/gold-card.svg").default} />
                  </div>
                  <div className="item">
                    <img alt="" src={require("assets/images/v1/vip/platinum-card.svg").default} />
                  </div>
                  <div className="item">
                    <img alt="" src={require("assets/images/v1/vip/diamond-card.svg").default} />
                  </div>
                </div>
                {/* <div className="data_row with_bg">
                  <div className="item">{__("Number of levels")}</div>
                  <div className="item text-center">1-4</div>
                  <div className="item text-center">1-4</div>
                  <div className="item text-center">1-4</div>
                  <div className="item text-center">1-4</div>
                  <div className="item text-center">1-4</div>
                </div> */}
                <div className="data_row ">
                  <div className="item">{__("Wagering requirements")}</div>
                  <div className="item text-center">$0 - $10,000</div>
                  <div className="item text-center">$10,001 - $50,000</div>
                  <div className="item text-center">$50,000 - $500,000</div>
                  <div className="item text-center">$500,000 - $20m</div>
                  <div className="item text-center">$20m+</div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("Rakeback")}</div>
                  <div className="item text-center">10%</div>
                  <div className="item text-center">10%</div>
                  <div className="item text-center">10%</div>
                  <div className="item text-center">10%</div>
                  <div className="item text-center">10%</div>
                </div>
                <div className="data_row ">
                  <div className="item">{__("Level up bonus")}</div>
                  <div className="item text-center">
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("Weekly Bonus")}</div>
                  <div className="item text-center">-</div>
                  <div className="item text-center">-</div>
                  <div className="item text-center">{__("yes")}</div>
                  <div className="item text-center">
                    {__("yes")} <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    {__("yes")} <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                </div>
                <div className="data_row">
                  <div className="item"> {__("VIP Host Bonus")}</div>
                  <div className="item text-center">-</div>
                  <div className="item text-center">-</div>
                  <div className="item text-center">-</div>
                  <div className="item text-center">
                    {__("yes")} <i className="fa fa-star"></i>
                  </div>
                  <div className="item text-center">
                    {__("yes")} <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rewards">
          <div className="container">
            <div className="heading">{__("Do you have a VIP Status somewhere else?")}</div>
            <div className="paragraph">
              {__(
                "If you have VIP status at any of the sites listed below – or any similar sites – let us know your current deal and we will do our best to beat it – we treat our VIPs like they have never been treated before, switch to us and we guarantee you won't be disappointed!"
              )}
            </div>

            <div className="sponsors">
              <div className="row">
                <div className="col-xl-8 offset-xl-2">
                  <div className="sponsors_icons">
                    <div className="single_icon">
                      <img alt="" src={require("assets/images/v1/vip/stake.svg").default} />
                    </div>
                    <div className="single_icon">
                      <img alt="" src={require("assets/images/v1/vip/roobet.svg").default} />
                    </div>
                    <div className="single_icon">
                      <img alt="" src={require("assets/images/v1/vip/duelbits.svg").default} />
                    </div>
                    <div className="single_icon">
                      <img alt="" src={require("assets/images/v1/vip/rollbit.svg").default} />
                    </div>
                  </div>
                  <div className="transfer">
                    <div className="item">{__("Transfer your VIP status")}</div>
                    <div className="item">
                      <svg width="108" height="58" viewBox="0 0 108 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1_1101_17987" fill="white">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M105.357 33.8493C108.118 31.9029 108.194 27.8349 105.508 25.7865L73.8984 1.68504C70.6417 -0.798138 65.9443 1.47278 65.8677 5.56748L65.5569 22.1638L5.74541 21.327C2.98426 21.2884 0.714586 23.4954 0.675955 26.2566L0.608489 31.0787C0.569859 33.8399 2.7769 36.1096 5.53805 36.1482L65.2793 36.984L64.9874 52.57C64.9107 56.6647 69.5198 59.1099 72.8672 56.7504L105.357 33.8493Z"
                          />
                        </mask>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M105.357 33.8493C108.118 31.9029 108.194 27.8349 105.508 25.7865L73.8984 1.68504C70.6417 -0.798138 65.9443 1.47278 65.8677 5.56748L65.5569 22.1638L5.74541 21.327C2.98426 21.2884 0.714586 23.4954 0.675955 26.2566L0.608489 31.0787C0.569859 33.8399 2.7769 36.1096 5.53805 36.1482L65.2793 36.984L64.9874 52.57C64.9107 56.6647 69.5198 59.1099 72.8672 56.7504L105.357 33.8493Z"
                          fill="white"
                          fill-opacity="0.29"
                        />
                        <path
                          d="M105.508 25.7865L106.114 24.9913L106.114 24.9913L105.508 25.7865ZM105.357 33.8493L105.933 34.6667L105.933 34.6667L105.357 33.8493ZM73.8984 1.68504L73.2921 2.48025L73.2921 2.48025L73.8984 1.68504ZM65.8677 5.56748L64.8678 5.54876L65.8677 5.56748ZM65.5569 22.1638L65.5429 23.1637L66.538 23.1776L66.5567 22.1825L65.5569 22.1638ZM65.2793 36.984L66.2791 37.0027L66.298 35.9982L65.2933 35.9841L65.2793 36.984ZM64.9874 52.57L65.9873 52.5887L65.9873 52.5887L64.9874 52.57ZM72.8672 56.7504L73.4433 57.5677L73.4433 57.5677L72.8672 56.7504ZM104.902 26.5817C107.051 28.2204 106.99 31.4749 104.781 33.032L105.933 34.6667C109.247 32.331 109.338 27.4494 106.114 24.9913L104.902 26.5817ZM73.2921 2.48025L104.902 26.5817L106.114 24.9913L74.5048 0.889824L73.2921 2.48025ZM66.8675 5.58621C66.9288 2.31045 70.6867 0.493712 73.2921 2.48025L74.5048 0.889824C70.5967 -2.08999 64.9599 0.635121 64.8678 5.54876L66.8675 5.58621ZM66.5567 22.1825L66.8675 5.58621L64.8678 5.54876L64.557 22.1451L66.5567 22.1825ZM5.73142 22.3269L65.5429 23.1637L65.5708 21.1639L5.7594 20.3271L5.73142 22.3269ZM1.67586 26.2705C1.70676 24.0616 3.5225 22.296 5.73142 22.3269L5.7594 20.3271C2.44602 20.2807 -0.27759 22.9292 -0.323947 26.2426L1.67586 26.2705ZM1.60839 31.0927L1.67586 26.2705L-0.323947 26.2426L-0.391413 31.0647L1.60839 31.0927ZM5.55204 35.1483C3.34312 35.1174 1.57749 33.3016 1.60839 31.0927L-0.391413 31.0647C-0.43777 34.3781 2.21068 37.1017 5.52407 37.1481L5.55204 35.1483ZM65.2933 35.9841L5.55204 35.1483L5.52407 37.1481L65.2653 37.9839L65.2933 35.9841ZM65.9873 52.5887L66.2791 37.0027L64.2795 36.9653L63.9876 52.5512L65.9873 52.5887ZM72.2911 55.933C69.6131 57.8206 65.9259 55.8645 65.9873 52.5887L63.9876 52.5512C63.8956 57.4649 69.4264 60.3991 73.4433 57.5677L72.2911 55.933ZM104.781 33.032L72.2911 55.933L73.4433 57.5677L105.933 34.6667L104.781 33.032Z"
                          fill="black"
                          mask="url(#path-1-inside-1_1101_17987)"
                        />
                      </svg>
                    </div>
                    <div className="item">
                      <svg width="118" height="74" viewBox="0 0 118 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1101_17976)">
                          <path
                            d="M113.317 0H80.1487C79.4668 0 78.8128 0.270896 78.3306 0.753092C77.8484 1.23529 77.5775 1.88929 77.5775 2.57121V6.81255C77.5775 7.49447 77.8484 8.14847 78.3306 8.63067C78.8128 9.11286 79.4668 9.38376 80.1487 9.38376H97.0295C97.48 9.38376 97.9226 9.5021 98.3129 9.72694C98.7032 9.95178 99.0277 10.2752 99.2537 10.6649C99.4797 11.0545 99.5994 11.4968 99.6007 11.9472C99.6021 12.3977 99.4851 12.8406 99.2614 13.2316L76.073 53.7773C75.8493 54.1683 75.7323 54.6112 75.7337 55.0617C75.735 55.5122 75.8547 55.9544 76.0807 56.344C76.3067 56.7337 76.6311 57.0571 77.0215 57.282C77.4118 57.5068 77.8544 57.6251 78.3049 57.6251H114.765C115.447 57.6251 116.101 57.3543 116.584 56.8721C117.066 56.3899 117.337 55.7359 117.337 55.0539V50.8126C117.337 50.1307 117.066 49.4767 116.584 48.9945C116.101 48.5123 115.447 48.2414 114.765 48.2414H94.5958C94.1453 48.2416 93.7026 48.1234 93.3121 47.8986C92.9215 47.6739 92.597 47.3505 92.3708 46.9608C92.1446 46.5711 92.0249 46.1288 92.0235 45.6782C92.022 45.2277 92.1391 44.7846 92.3628 44.3935L115.55 3.84786C115.773 3.45684 115.89 3.01392 115.889 2.56346C115.888 2.113 115.768 1.6708 115.542 1.28113C115.316 0.891472 114.991 0.568027 114.601 0.343187C114.211 0.118346 113.768 -1.01264e-06 113.318 0"
                            fill="url(#paint0_linear_1101_17976)"
                          />
                          <path
                            d="M66.9027 57.6251H3.44792C2.76625 57.6243 2.11273 57.3531 1.63071 56.8711C1.14869 56.3891 0.877534 55.7356 0.876709 55.0539V16.5321C0.877534 15.8504 1.14869 15.1969 1.63071 14.7149C2.11273 14.2329 2.76625 13.9617 3.44792 13.9609H88.9326C89.3833 13.9582 89.8267 14.0753 90.2174 14.3001C90.6081 14.525 90.9321 14.8495 91.1563 15.2407C91.385 15.6296 91.5063 16.0723 91.5078 16.5235C91.5093 16.9748 91.3909 17.4183 91.1648 17.8087L76.0652 44.2128C76.0576 44.212 76.0501 44.2103 76.043 44.2077C76.0352 44.2047 76.0271 44.203 76.0188 44.2026H67.6355C67.4103 44.2026 67.1891 44.1434 66.994 44.0311C66.7989 43.9187 66.6367 43.757 66.5237 43.5623C66.4107 43.3675 66.3508 43.1465 66.35 42.9214C66.3493 42.6962 66.4077 42.4748 66.5194 42.2793L76.3831 25.0307C76.4948 24.8352 76.5532 24.6138 76.5524 24.3887C76.5516 24.1635 76.4918 23.9425 76.3788 23.7477C76.2657 23.553 76.1036 23.3913 75.9084 23.279C75.7133 23.1666 75.4921 23.1074 75.2669 23.1074H61.2032C60.8622 23.1074 60.5352 23.2428 60.2941 23.4839C60.053 23.725 59.9176 24.052 59.9176 24.393V25.9256C59.9176 26.2666 60.053 26.5936 60.2941 26.8347C60.5352 27.0758 60.8622 27.2112 61.2032 27.2112H68.1459C68.371 27.2112 68.5922 27.2704 68.7873 27.3828C68.9825 27.4951 69.1446 27.6568 69.2577 27.8515C69.3707 28.0463 69.4306 28.2673 69.4313 28.4925C69.4321 28.7176 69.3737 28.939 69.262 29.1345L59.3979 46.3835C59.2862 46.579 59.2278 46.8004 59.2286 47.0256C59.2293 47.2507 59.2892 47.4717 59.4022 47.6665C59.5152 47.8612 59.6774 48.0229 59.8725 48.1353C60.0677 48.2476 60.2889 48.3068 60.514 48.3068H73.7242L69.1358 56.3321C68.9102 56.725 68.5849 57.0514 68.1929 57.2785C67.8008 57.5055 67.3558 57.6251 66.9027 57.6251ZM16.7454 48.3064H17.7801V49.8355C17.7801 50.2488 17.9443 50.6452 18.2365 50.9374C18.5288 51.2297 18.9251 51.3938 19.3384 51.3938H19.8449C20.2581 51.3938 20.6545 51.2297 20.9467 50.9374C21.239 50.6452 21.4032 50.2488 21.4032 49.8355V48.285C23.5618 48.1658 25.3165 47.5405 26.6188 46.4256C28.0759 45.1789 28.8149 43.3997 28.8149 41.1429C28.8149 39.255 28.3123 37.7169 27.3208 36.5712C26.8858 36.0764 26.3735 35.6554 25.8038 35.3245C25.6321 35.2215 25.4849 35.0822 25.3725 34.9164C25.2602 34.7506 25.1853 34.5623 25.1532 34.3646C25.1222 34.1881 25.1312 34.0069 25.1796 33.8344C25.2279 33.6619 25.3144 33.5024 25.4326 33.3677C25.5653 33.2168 25.688 33.0574 25.7999 32.8905C26.4966 31.7858 26.8448 30.497 26.7992 29.1918C26.7992 27.2225 26.2028 25.6993 25.0262 24.6649C23.9887 23.834 22.7276 23.3301 21.4032 23.2173V21.3777C21.4026 20.9645 21.2383 20.5685 20.9462 20.2763C20.654 19.9842 20.258 19.8199 19.8449 19.8194H19.3384C18.9251 19.8194 18.5288 19.9835 18.2365 20.2758C17.9443 20.568 17.7801 20.9644 17.7801 21.3777V23.1074H16.7454V21.3777C16.7449 20.9645 16.5805 20.5685 16.2884 20.2763C15.9963 19.9842 15.6002 19.8199 15.1871 19.8194H14.6806C14.2673 19.8194 13.871 19.9835 13.5787 20.2758C13.2865 20.568 13.1223 20.9644 13.1223 21.3777V23.1074H11.3793C11.0384 23.1074 10.7114 23.2428 10.4703 23.4839C10.2292 23.725 10.0937 24.052 10.0937 24.393V47.0208C10.0937 47.3618 10.2292 47.6888 10.4703 47.9299C10.7114 48.171 11.0384 48.3064 11.3793 48.3064H13.1239V49.8355C13.1239 50.2488 13.288 50.6452 13.5803 50.9374C13.8725 51.2297 14.2689 51.3938 14.6822 51.3938H15.1886C15.6019 51.3938 15.9983 51.2297 16.2905 50.9374C16.5828 50.6452 16.7469 50.2488 16.7469 49.8355V48.3068L16.7454 48.3064ZM51.9141 23.107C51.5731 23.107 51.2461 23.2425 51.005 23.4835C50.764 23.7246 50.6285 24.0516 50.6285 24.3926V47.0208C50.6285 47.3618 50.764 47.6888 51.005 47.9299C51.2461 48.171 51.5731 48.3064 51.9141 48.3064H53.9508C54.2918 48.3064 54.6188 48.171 54.8599 47.9299C55.101 47.6888 55.2364 47.3618 55.2364 47.0208V24.393C55.2364 24.052 55.101 23.725 54.8599 23.4839C54.6188 23.2428 54.2918 23.1074 53.9508 23.1074L51.9141 23.107ZM33.9156 23.107C33.5747 23.107 33.2477 23.2425 33.0066 23.4835C32.7655 23.7246 32.63 24.0516 32.63 24.3926V47.0208C32.63 47.3618 32.7655 47.6888 33.0066 47.9299C33.2477 48.171 33.5747 48.3064 33.9156 48.3064H46.3198C46.6607 48.3064 46.9877 48.171 47.2288 47.9299C47.4699 47.6888 47.6054 47.3618 47.6054 47.0208V45.4882C47.6054 45.1473 47.4699 44.8203 47.2288 44.5792C46.9877 44.3381 46.6607 44.2026 46.3198 44.2026H38.5224C38.1814 44.2026 37.8544 44.0672 37.6133 43.8261C37.3722 43.585 37.2368 43.258 37.2368 42.917V24.393C37.2368 24.052 37.1013 23.725 36.8602 23.4839C36.6191 23.2428 36.2921 23.1074 35.9512 23.1074L33.9156 23.107ZM19.9212 44.2026H15.9865C15.6455 44.2026 15.3185 44.0672 15.0774 43.8261C14.8363 43.585 14.7009 43.258 14.7009 42.917V38.3979C14.7009 38.057 14.8363 37.73 15.0774 37.4889C15.3185 37.2478 15.6455 37.1123 15.9865 37.1123H19.9212C20.9548 37.0774 21.9775 37.333 22.873 37.8502C23.6615 38.3407 24.0613 39.2795 24.0613 40.6403C24.0613 41.9778 23.6826 42.9166 22.9362 43.4301C22.0322 43.9861 20.9811 44.2554 19.9212 44.2026ZM18.9142 33.0069H15.9873C15.6463 33.0069 15.3193 32.8715 15.0782 32.6304C14.8371 32.3893 14.7016 32.0623 14.7016 31.7213V28.4968C14.7016 28.1558 14.8371 27.8288 15.0782 27.5877C15.3193 27.3466 15.6463 27.2112 15.9873 27.2112H18.9142C20.0252 27.2112 20.8698 27.4383 21.4254 27.8863C21.9809 28.3344 22.2622 29.0882 22.2622 30.1272C22.2622 31.13 21.9805 31.8686 21.4254 32.3232C20.8702 32.7779 20.0244 33.0069 18.9142 33.0069Z"
                            fill="url(#paint1_linear_1101_17976)"
                          />
                          <path
                            d="M105.681 73.6866C104.47 73.4735 103.765 73.015 103.355 72.2132C102.93 71.4115 102.831 70.6082 102.831 68.2174C102.831 66.3844 102.864 65.9251 103.062 65.1892C103.373 64.0251 104.011 63.4037 105.239 63.043C106.157 62.7808 107.156 62.7161 110.037 62.7161C113.181 62.7161 114.147 62.7477 114.917 62.8794C116.604 63.191 117.423 64.0578 117.652 65.8102C117.737 66.6918 117.769 67.5777 117.75 68.4632C117.75 71.0991 117.472 72.1642 116.538 72.9332C115.883 73.4903 114.966 73.7513 113.378 73.8183C112.788 73.8499 111.331 73.867 110.267 73.867C107.663 73.8674 106.337 73.8191 105.681 73.6866ZM106.762 65.7782C106.321 66.1218 106.189 66.6633 106.189 68.2353C106.189 69.8399 106.321 70.4286 106.729 70.7722C107.171 71.1329 107.711 71.2007 110.218 71.2007C113.083 71.2007 113.673 71.1018 114.05 70.5774C114.361 70.1851 114.442 69.6284 114.442 68.1706C114.442 65.4198 114.393 65.3871 110.3 65.3871C107.859 65.3851 107.189 65.4669 106.762 65.7774V65.7782ZM2.3298 73.1128C1.24989 72.4256 0.938232 71.2802 0.938232 68.037C0.938232 65.1549 1.26626 64.1241 2.41278 63.4692C3.39491 62.8953 4.44443 62.7481 7.50456 62.7481C11.5823 62.7481 12.467 62.8295 13.3993 63.2876C14.284 63.729 14.6934 64.6963 14.6934 66.3002V66.6594H11.5164C11.4506 65.4654 11.2048 65.3668 8.3219 65.3668C5.60303 65.3668 5.11334 65.4323 4.70233 65.793C4.31003 66.1522 4.22822 66.5948 4.22822 68.3642C4.22822 70.9849 4.47326 71.1809 7.66741 71.1809C10.1401 71.1809 10.4996 71.1637 10.9578 70.9689C11.4331 70.771 11.6134 70.4274 11.6134 69.6416H14.8423C14.8236 71.2296 14.7749 71.7707 14.5462 72.2619C14.1208 73.1969 13.236 73.6368 11.5336 73.7525C10.8619 73.8171 9.55179 73.8343 7.37405 73.8343C4.22977 73.8343 3.21492 73.6866 2.3298 73.1128ZM46.6781 73.2604C46.0065 72.9328 45.6629 72.0979 45.6629 70.8061C45.6629 70.7071 45.6629 70.4944 45.6789 70.265H48.9381C48.9708 71.018 49.0522 71.2 49.4445 71.346C50.1781 71.4845 50.925 71.5393 51.671 71.5093C55.5196 71.5093 55.9781 71.3951 55.9781 70.494C55.994 70.3062 55.9482 70.1184 55.8476 69.9589C55.7471 69.7995 55.5973 69.6772 55.421 69.6105C55.0603 69.4963 55.0603 69.4963 53.3423 69.4792H50.3285C48.3152 69.4792 47.4791 69.3647 46.7748 69.0051C45.9902 68.5956 45.6294 67.7277 45.6294 66.2391C45.6294 64.2737 46.1865 63.4388 47.7573 63.0621C48.642 62.8326 49.919 62.7504 52.3103 62.7504C56.1414 62.7504 57.0265 62.8474 57.8127 63.3558C58.5657 63.8623 58.8104 64.5343 58.8104 66.1725H55.5691C55.5691 65.2231 55.2411 65.091 53.096 65.091C52.0321 65.091 50.6063 65.1241 50.0827 65.1568C49.1991 65.2227 48.9042 65.4517 48.9042 66.0735C48.8902 66.2805 48.9551 66.4851 49.0857 66.6462C49.2164 66.8074 49.4032 66.9131 49.6086 66.9423C50.051 67.0255 50.5021 67.0529 50.9514 67.0241H54.0455C54.3404 67.0241 55.8137 67.0728 56.3708 67.1059C58.4512 67.2033 59.2701 68.1207 59.2701 70.3148C59.2701 72.329 58.6803 73.2141 57.0752 73.5577C56.2571 73.7381 54.6353 73.8354 52.2616 73.8354C48.4796 73.8327 47.6447 73.7513 46.6785 73.2604H46.6781ZM89.1421 73.7521L82.6245 65.532L82.7063 73.7521H79.5117V62.8303H84.801L91.4165 71.131L91.3346 62.8303H94.4789V73.7521H89.1421ZM67.5907 73.7521V62.8295H70.9138V73.7513L67.5907 73.7521ZM34.8541 73.7521L33.773 71.8042H26.7306L25.6838 73.7521H21.917L28.0575 62.8295H32.5119L38.4884 73.7513L34.8541 73.7521ZM27.9262 69.5271H32.6109L30.2516 65.1705L27.9262 69.5271Z"
                            fill="#264EF8"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_1101_17976"
                            x1="114.508"
                            y1="57.6251"
                            x2="80.4366"
                            y2="27.8642"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#264EF8" />
                            <stop offset="1" stop-color="#4DE8FF" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_1101_17976"
                            x1="0.876711"
                            y1="57.6251"
                            x2="34.8585"
                            y2="-11.7629"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#264EF8" />
                            <stop offset="1" stop-color="#4DE8FF" />
                          </linearGradient>
                          <clipPath id="clip0_1101_17976">
                            <rect width="116.873" height="73.867" fill="white" transform="translate(0.876709)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>

                  <div className="transfer_btn text-center">
                    <Link className="common_btn_v1 width_100">{__("Coming soon")}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rewards">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="heading">{__("Enjoy daily rakeback on your previous days bets!")}</div>
                <div className="paragraph">
                  {__(
                    "Don’t want to wait a week to get your cashback? Never fear, we hear you! At Blizz, if you deposit and lose just Spin the Blizz Rakeback Wheel the next day to get cash added to your account from the previous days play giving you a second chance to win – why wait a week for cashback when you can get a daily bonus?"
                  )}
                </div>
              </div>
              <div className="col-md-5">
                <div className="reward_img">
                  <img alt="" src={require("assets/images/v1/vip/rakeback-img.png").default} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rewards">
          <div className="container">
            <div className="heading">{__("Weekly Reloads Skyrocket your Winning Chances!")}</div>
            <div className="paragraph">
              {__(
                "On top of our standard weekly promotions, such as Tasty Tuesdays (75% reload bonus) and Free Spins Thursdays (free spins depending on 1st deposit amount of the day), VIPs at Blizz are entitled to bigger and better reloads and much more besides!"
              )}
            </div>
            <div className="row ">
              <div className="col-md-6">
                <div className="reward_img ">
                  <img alt="" src={require("assets/images/v1/vip/weekly-slots.svg").default} />
                </div>
                <div className="heading">{__("Over 5,000 great games to choose from")}</div>
              </div>
              <div className="col-md-6">
                <div className="reward_img ">
                  <img alt="" src={require("assets/images/v1/vip/weekly-calender.svg").default} />
                </div>
                <div className="heading">{__("Weekly and Monthly VIP only promotions and races")}</div>
              </div>
            </div>
          </div>
        </section>
        <section className="rewards d-none">
          <div className="container">
            <div className="heading">{__("Blizz Rakeback Wheel!")}</div>
            <div className="paragraph">
              {__(
                "How's your luck? Spin the Blizz Rakeback Wheel every day for free and find out – daily prizes to be won for all VIPs – Coming soon, only to Blizz!"
              )}
            </div>

            <div className="reward_img">
              <img alt="" src={require("assets/images/v1/vip/wheels.png").default} />
            </div>
            <br />
            <br />
            <div className="sponsors">
              <div className="transfer_btn text-center">
                <Link className="common_btn_v1 width_100">{__("Coming soon")}</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="rewards wheels_area">
          <div className="container">
            <div className="heading main_heading">{__("Blizz Rakeback Wheel!")}</div>
            <div className="paragraph">{__("A Prize Guaranteed every day you don't win!")}</div>

            <div className="paragraph">
              {__("How's your luck? At Blizz, we want to give you the chance to be lucky, even when you're not!")}
            </div>
            <div className="paragraph">
              {__(
                "Each day you play and don't win, you will be able to spin the Blizz Rakeback Wheel the next day, from 00.00 to 23.59 CET."
              )}
            </div>
            <div className="paragraph">
              {__(
                "The amount you turnover determines the tier from which you will spin the wheel, there is a Diamond, Gold, Silver and Bronze one. You will be able to win a % of rakeback on your previous day's wagers, from 5% up to 50% - On top of the standard 10% weekly cashback."
              )}
            </div>
            <div className="paragraph">{__("The prizes for each tier are as follows:")}</div>

            <div className="table_area">
              <div className="rewards_table">
                <div className="data_heading">
                  <div className="item">{__("Tier")}</div>
                  <div className="item">{__("Diamond")}</div>
                  <div className="item">{__("Gold")}</div>
                  <div className="item">{__("Silver")}</div>
                  <div className="item">{__("Bronze")}</div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("Turnover Needed")}</div>
                  <div className="item ">{__("$25,000 or more")}</div>
                  <div className="item ">{__("$15,000 - $24,999")}</div>
                  <div className="item ">{__("$7,500 - $14,999")}</div>
                  <div className="item ">{__("$1 - $7,499")}</div>
                </div>
                <div className="data_row">
                  <div className="item">{__("Top Prize")}</div>
                  <div className="item ">{__("50% Rakeback")}</div>
                  <div className="item ">{__("35% Rakeback")}</div>
                  <div className="item ">{__("25% Rakeback")}</div>
                  <div className="item ">{__("15% Rakeback")}</div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("2nd Prize")}</div>
                  <div className="item ">{__("45% Rakeback")}</div>
                  <div className="item ">{__("31% Rakeback")}</div>
                  <div className="item ">{__("22% Rakeback")}</div>
                  <div className="item ">{__("13% Rakeback")}</div>
                </div>
                <div className="data_row">
                  <div className="item">{__("3rd Prize")}</div>
                  <div className="item ">{__("40% Rakeback")}</div>
                  <div className="item ">{__("27% Rakeback")}</div>
                  <div className="item ">{__("19% Rakeback")}</div>
                  <div className="item ">{__("11% Rakeback")}</div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("4th Prize")}</div>
                  <div className="item ">{__("35% Rakeback")}</div>
                  <div className="item ">{__("23% Rakeback")}</div>
                  <div className="item ">{__("16% Rakeback")}</div>
                  <div className="item ">{__("9% Rakeback")}</div>
                </div>
                <div className="data_row">
                  <div className="item">{__("5th Prize")}</div>
                  <div className="item ">{__("30% Rakeback")}</div>
                  <div className="item ">{__("19% Rakeback")}</div>
                  <div className="item ">{__("13% Rakeback")}</div>
                  <div className="item ">{__("7% Rakeback")}</div>
                </div>
                <div className="data_row with_bg">
                  <div className="item">{__("6th Prize")}</div>
                  <div className="item ">{__("25% Rakeback")}</div>
                  <div className="item ">{__("15% Rakeback")}</div>
                  <div className="item ">{__("10% Rakeback")}</div>
                  <div className="item ">{__("5% Rakeback")}</div>
                </div>
              </div>
            </div>
            <br />
            <div className="paragraph">
              {__(
                "The turnover needed depends on which wheel you get to spin the following day and does not affect your loyalty level. The more you turnover, the more you could get back."
              )}
              <br />
              {__(
                "Any winnings from the Blizz Rakeback Wheel are paid in cash. Winnings will be added to accounts instantly once the spin has completed."
              )}
              <br />
              {__(
                "Standard promotional terms apply, Blizz reserves the right to change, modify or remove this promotion at any time without giving a reason."
              )}
            </div>

            <div className="wheels_group">
              <div className="single_wheel leftWheel">
                <div className="wheel_item">
                  <img alt="" src={require("assets/images/v1/vip/bronze-wheel-two.svg").default} />
                </div>
                <div className="wheel_item">
                  <h3 className="heading">{__("Bronze Wheel")}</h3>
                  <div className="wheel_text">
                    {__(
                      "Turnover between $1 and $7,499 and finish down, and the next day you get to spin the Bronze Wheel. Between 0.1% and 5% of your losses will be paid back into your account as soon as the wheel has been spun!"
                    )}
                  </div>
                  <div className="table_area">
                    <div className="rewards_table">
                      <div className="data_heading">
                        <div className="item">{__("Tier")}</div>
                        <div className="item">{__("Bronze")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("Turnover Needed")}</div>
                        <div className="item ">{__("$1 - $7,499")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("Top Prize")}</div>
                        <div className="item ">{__("15% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("2nd Prize")}</div>
                        <div className="item ">{__("13% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("3rd Prize")}</div>
                        <div className="item ">{__("11% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("4th Prize")}</div>
                        <div className="item ">{__("9% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("5th Prize")}</div>
                        <div className="item ">{__("7% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("6th Prize")}</div>
                        <div className="item ">{__("5% Rakeback")}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="single_wheel rightWheel">
                <div className="wheel_item">
                  <h3 className="heading">{__("Silver Wheel")}</h3>
                  <div className="wheel_text">
                    {__(
                      "Turnover between $7,500 and $14,999 and finish down, and the next day you get to spin the Silver Wheel. Between 1% and 6% of your losses will be paid back into your account as soon as the wheel has been spun!"
                    )}
                  </div>
                  <div className="table_area">
                    <div className="rewards_table">
                      <div className="data_heading">
                        <div className="item">{__("Tier")}</div>
                        <div className="item">{__("Silver")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("Turnover Needed")}</div>
                        <div className="item ">{__("$7,500 - $14,999")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("Top Prize")}</div>
                        <div className="item ">{__("25% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("2nd Prize")}</div>
                        <div className="item ">{__("22% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("3rd Prize")}</div>
                        <div className="item ">{__("19% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("4th Prize")}</div>
                        <div className="item ">{__("16% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("5th Prize")}</div>
                        <div className="item ">{__("13% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("6th Prize")}</div>
                        <div className="item ">{__("10% Rakeback")}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wheel_item">
                  <img alt="" src={require("assets/images/v1/vip/silver-wheel-two.svg").default} />
                </div>
              </div>
              <div className="single_wheel leftWheel">
                <div className="wheel_item">
                  <img alt="" src={require("assets/images/v1/vip/gold-wheel-two.svg").default} />
                </div>
                <div className="wheel_item">
                  <h3 className="heading">{__("Gold Wheel")}</h3>
                  <div className="wheel_text">
                    {__(
                      "Turnover between $15,000 and $24,999 and finish down, and the next day you get to spin the Gold Wheel. Between 1% and 7.5% of your losses will be paid back into your account as soon as the wheel has been spun!"
                    )}
                  </div>
                  <div className="table_area">
                    <div className="rewards_table">
                      <div className="data_heading">
                        <div className="item">{__("Tier")}</div>
                        <div className="item">{__("Gold")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("Turnover Needed")}</div>
                        <div className="item ">{__("$15,000 - $24,999")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("Top Prize")}</div>
                        <div className="item ">{__("35% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("2nd Prize")}</div>
                        <div className="item ">{__("31% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("3rd Prize")}</div>
                        <div className="item ">{__("27% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("4th Prize")}</div>
                        <div className="item ">{__("23% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("5th Prize")}</div>
                        <div className="item ">{__("19% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("6th Prize")}</div>
                        <div className="item ">{__("15% Rakeback")}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="single_wheel rightWheel">
                <div className="wheel_item">
                  <h3 className="heading">{__("Diamond Wheel")}</h3>
                  <div className="wheel_text">
                    {__(
                      "Turnover $25,000 or more and finish down, and the next day you get to spin the Diamond Wheel. Between 2% and 10% of your losses will be paid back into your account as soon as the wheel has been spun!"
                    )}
                  </div>
                  <div className="table_area">
                    <div className="rewards_table">
                      <div className="data_heading">
                        <div className="item">{__("Tier")}</div>
                        <div className="item">{__("Diamond")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("Turnover Needed")}</div>
                        <div className="item ">{__("$25,000 or more")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("Top Prize")}</div>
                        <div className="item ">{__("50% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("2nd Prize")}</div>
                        <div className="item ">{__("45% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("3rd Prize")}</div>
                        <div className="item ">{__("40% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("4th Prize")}</div>
                        <div className="item ">{__("35% Rakeback")}</div>
                      </div>
                      <div className="data_row">
                        <div className="item">{__("5th Prize")}</div>
                        <div className="item ">{__("30% Rakeback")}</div>
                      </div>
                      <div className="data_row with_bg">
                        <div className="item">{__("6th Prize")}</div>
                        <div className="item ">{__("25% Rakeback")}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wheel_item">
                  <img alt="" src={require("assets/images/v1/vip/diamond-wheel-two.svg").default} />
                </div>
              </div>
            </div>

            <div className="sponsors">
              <div className="transfer_btn text-center">
                <Link className="common_btn_v1 width_100">{__("Coming soon")}</Link>
              </div>
            </div>

            <div className="rakeback_area">
              <div className="rakeback_top">
                <div className="heading">{__("Blizz Rakeback")}</div>
                <div className="paragraph">
                  {__(
                    "Blizz Rakeback is our little way of saying…you’re valued. We hope you know that, this is us proving it. Level up and get increased daily, weekly and monthly cashback, so if you are up you are happy, if you are not you still get a little something extra back, courtesy of Blizz!"
                  )}
                </div>
              </div>
              <div className="rakeback_items">
                <div className="rakeback_single_item">
                  <div className="left_item">
                    <img alt="" src={require("assets/images/v1/vip/daily-icon.svg").default} />
                  </div>
                  <div className="right_item">
                    <div className="rakeback_item_heading">{__("Daily Rakeback")}</div>
                    <div className="rakeback_item_content">
                      {__(
                        "Get up to 50% Rakeback from your previous days play by spinning the Blizz Rakeback Wheel. Every day you play and finish behind, you are guaranteed some funds back the next day!"
                      )}
                    </div>
                  </div>
                </div>
                <div className="rakeback_single_item">
                  <div className="left_item">
                    <img alt="" src={require("assets/images/v1/vip/weekly-icon.svg").default} />
                  </div>
                  <div className="right_item">
                    <div className="rakeback_item_heading">{__("Weekly Cashback")}</div>
                    <div className="rakeback_item_content">
                      {__(
                        "The more you play, the more you will level up. Level up far enough, and the 10% all players that are $250 or more down get back weekly will be increased, just for you!"
                      )}
                    </div>
                  </div>
                </div>
                <div className="rakeback_single_item">
                  <div className="left_item">
                    <img alt="" src={require("assets/images/v1/vip/monthly-icon.svg").default} />
                  </div>
                  <div className="right_item">
                    <div className="rakeback_item_heading">{__("Monthly Bonus")}</div>
                    <div className="rakeback_item_content">
                      {__(
                        "Play enough and get a guaranteed monthly bonus based on your play each and every month you are behind. Just another extra as a thank you for your custom at Blizz!"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
